import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { AppCompatibilityComponent } from './app/app-compatibility/app-compatibility.component';

function checkBrowserCompatibility(): string {
  const userAgent = window.navigator.userAgent;
  const isChrome = userAgent.indexOf('Chrome/') > -1;
  const isFirefox = userAgent.indexOf('Firefox/') > -1;
  const isSafari = userAgent.indexOf('Safari/') > -1;
  const isEdge = userAgent.indexOf('Edge/') > -1;

  if (isChrome || isEdge || isFirefox || isSafari) {
    return 'app-root';
  }
  return 'app-compatibility';
}

const selector = checkBrowserCompatibility();
const component = selector === 'app-root' ? AppComponent : AppCompatibilityComponent;

const componentElement = document.createElement(selector);
document.body.appendChild(componentElement);

const appSpinner = document.querySelector('.app-loading');
if (appSpinner?.parentElement) {
  appSpinner.parentElement.removeChild(appSpinner);
}

bootstrapApplication(component, appConfig)
  .catch(err => console.error(err));
